















import Vue from 'vue';
import type { PropOptions } from 'vue';
import { referenceableTypes } from '@/components/global/HeaderMenu/HeaderMenuNotifications/constants';
import HeaderMenuNotificationsCardGrid from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGrid.vue';
import HeaderMenuNotificationsCardGridAvatar from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGridAvatar/HeaderMenuNotificationsCardGridAvatar.vue';
import type { Notification, User, Comment, Post, Rating } from '@/types/graphql';

export default Vue.extend({
  name: 'HeaderMenuNotificationsCardRating',
  components: {
    HeaderMenuNotificationsCardGrid,
    HeaderMenuNotificationsCardGridAvatar,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    } as PropOptions<Notification>,
  },
  computed: {
    referenceable(): Rating {
      return this.notification.referenceable as Rating;
    },
    reactable(): Comment & Post {
      return this.referenceable.reactable as Comment & Post;
    },
    user(): User {
      return this.referenceable.user;
    },
    reactableType(): string {
      return this.referenceable.reactable.__typename ? this.referenceable.reactable.__typename.toLowerCase() : '';
    },
    postTitle(): string {
      return this.reactable.__typename === referenceableTypes.POST ? this.reactable.content.title : '';
    },
  },
});
